/** Hours after planned end before an occurrence auto-transitions to Concluded (matches backend occurrenceStatus.js). */
export const AUTO_CONCLUDE_GRACE_MS = 4 * 60 * 60 * 1000;

function parseTime(value) {
  if (value == null) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function getAutoConcludeAt(endTime) {
  const end = parseTime(endTime);
  if (!end) return null;
  return new Date(end.getTime() + AUTO_CONCLUDE_GRACE_MS);
}

function resolveStatus({
  startTime,
  endTime,
  isCancelled,
  tentative,
  concludedAt = null,
  now = new Date(),
}) {
  const currentTime = parseTime(now) || new Date();
  const start = parseTime(startTime);
  const end = parseTime(endTime);
  const concluded = parseTime(concludedAt);

  if (isCancelled) return "Canceled";

  if (concluded && currentTime >= concluded) return "Concluded";

  const autoConcludeAt = getAutoConcludeAt(endTime);

  if (autoConcludeAt) {
    if (currentTime >= autoConcludeAt) return "Concluded";
    if (start && currentTime >= start && currentTime < autoConcludeAt) return "Live";
  } else if (start && currentTime >= start) {
    return "Live";
  }

  if (tentative) return "Tentative";
  if (start && currentTime < start) return "Scheduled";
  return undefined;
}

export function getStatusFromCalendarEvent(event) {
  return resolveStatus({
    startTime: event.start,
    endTime: event.end,
    isCancelled: event.isCancelled,
    tentative: event.tentative,
    concludedAt: event.concludedAt,
  });
}

function pickOccurrenceForStatus(eventDetails, selectedOccurrence) {
  const list = eventDetails.occurrences;
  const oid = selectedOccurrence?.occurrenceId ?? selectedOccurrence?.id;
  if (oid == null) return list[0];
  const n = Number(oid);
  const found = list.find(
    (o) =>
      (o.id != null && Number(o.id) === n) ||
      (o.occurrenceId != null && Number(o.occurrenceId) === n)
  );
  return found || list[0];
}

/** Use selectedOccurrence when provided so recurring events match the opened occurrence, not occurrences[0]. */
export function getStatusFromEventDetails(eventDetails, selectedOccurrence = null) {
  if (!eventDetails || !eventDetails.occurrences || eventDetails.occurrences.length === 0) return null;
  const occurrence = pickOccurrenceForStatus(eventDetails, selectedOccurrence);
  return resolveStatus({
    startTime: occurrence.startTime,
    endTime: occurrence.endTime,
    isCancelled: occurrence.isCancelled,
    tentative: eventDetails.tentative,
    concludedAt: occurrence.concludedAt,
  });
}
